// extracted by mini-css-extract-plugin
export var content = "Main-module--content--7f069";
export var topPaddingNone = "Main-module--topPaddingNone--c4205";
export var bottomPaddingNone = "Main-module--bottomPaddingNone--2bf7c";
export var marginDisable = "Main-module--marginDisable--3b18b";
export var whiteBG = "Main-module--whiteBG--82c3c";
export var scrollY = "Main-module--scrollY--c2833";
export var stretchViewportHeight = "Main-module--stretchViewportHeight--b4bc2";
export var hidden = "Main-module--hidden--9b1c5";